import React from "react";
import { useParams } from 'react-router-dom';
import { AllProjects } from "../projects/AllProjects.js";

import extLinkIconWhite from "../img/External_Link_white.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Project() {

  let projectParam = useParams();
  let projectName = projectParam.project;

  let thisProject = AllProjects.find((project)=>project.shortTitle === projectName);

  const langCats = {
    FE: ["HTML5", "CSS3", "JS/ES6", "React", "MJML", "ExtendScript", "SCSS"],
    PG: ["AfterEffects", "Illustrator", "AdobeXD", "Figma"],
    BE: ["PHP", "MySQL"],
  };

  return (
    <div className="Project" id={thisProject.shortTitle}>
      {thisProject.heroImage && (
        <LazyLoadImage
        className={thisProject.optstyles}
        src={thisProject.heroImage.src}
        alt={thisProject.heroImage.alt}
        />
      )}

      {thisProject.heroVideo && (
        <div className="iframe-container">
          <iframe
            src={thisProject.heroVideo}
            title={thisProject.title}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
        <h3 className="ProjTitle">{thisProject.title}</h3>
        <div className="BuiltWith">
          {thisProject.extLink && (
            <p>
              <a href={thisProject.extLink} target="_blank" rel="noreferrer">
                <button>
                  {thisProject.extLinkText}
                  <LazyLoadImage
                    src={extLinkIconWhite}
                    style={{ height: 15, width: 15, paddingLeft: 5 }}
                    alt="external link icon"
                  />
                </button>
              </a>
            </p>
          )}
            <p>
              {thisProject.skills.find((skill) =>
                langCats.FE.includes(skill)
              ) && <span className="BuiltCat">Front-end</span>}

              {thisProject.skills
                .filter((skill) => langCats.FE.includes(skill))
                .map((skill) => {
                  return <span>{skill}</span>;
                })}
            </p>
            <p>
              {thisProject.skills.find((skill) =>
                langCats.BE.includes(skill)
              ) && <span className="BuiltCat">Back-end</span>}
              {thisProject.skills
                .filter((skill) => langCats.BE.includes(skill))
                .map((skill) => {
                  return <span>{skill}</span>;
                })}
            </p>
            <p>
              {thisProject.skills.find((skill) =>
                langCats.PG.includes(skill)
              ) && <span className="BuiltCat">Design Programs</span>}
              {thisProject.skills
                .filter((skill) => langCats.PG.includes(skill))
                .map((skill) => {
                  return <span>{skill}</span>;
                })}
            </p>
        </div>
        <div className="IntroText">
          {thisProject.introText.map((introText) => (
            <p key={introText.index} index={introText.index}>
              {introText.text}
            </p>
          ))}
        </div>

      <div className="ProjDesc">
        {thisProject.imgsParas.map((para) => (
          <div key={para.index} className="DescSec">
            <LazyLoadImage
              src={para.img.src}
              alt={para.img.alt}
              className={thisProject.optstyles}
            />
            <p>{para.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Project;
